import { apiUrl } from "../../apiClient";

import { endpoint } from "../endpoint";
import { customBaseQuery } from "../customBaseQuery";
const { createApi } = require("@reduxjs/toolkit/query/react");

export const admin_vendor_api = createApi({
  reducerPath: "vendor-workflow-reducer",
  baseQuery: customBaseQuery,
  endpoints: (builder) => ({
    approver: builder.mutation({
      query: (data) => ({
        url: `${endpoint.admin_vendor}/vendor-workflow-data/${data?.vendor_id}`,
        method: "PATCH",
        body: data,
        headers: {
        },
      }),
    }),
  }),
});

export const { useApproverMutation } = admin_vendor_api;
